module.exports = __webpack_public_path__ + "static/img/BE.0800d73d.jpg";